<div fxLayout="column" class="profile" fxLayoutGap="12px">
  <div fxLayoutAlign="start center" fxLayout="row">
    <img *ngIf="thumbnailPhotoUrl; else defaultPhoto" [src]="thumbnailPhotoUrl" class="grid-avatar">
    <ng-template #defaultPhoto>
      <img [src]="getDefaultPhotoUrl()" class="grid-avatar">
    </ng-template>
    <div fxLayout="column">
      <strong>{{name}}</strong>
      <span class="secondary-text font-size-11">{{email}}</span>
    </div>
  </div>
  <div class="ou-path" *ngIf="ouPath">Org unit: <em>{{ouPath}}</em></div>
</div>
